import { render } from "./CRMstatistics.vue?vue&type=template&id=27380d5e&scoped=true"
import script from "./CRMstatistics.vue?vue&type=script&lang=js"
export * from "./CRMstatistics.vue?vue&type=script&lang=js"

import "./CRMstatistics.vue?vue&type=style&index=0&id=27380d5e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-27380d5e"

export default script